/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ResourceDescription } from './resourceDescription';
import type { AppSchemasApiResourcesMediaType } from './appSchemasApiResourcesMediaType';
import type { ResourceUrl } from './resourceUrl';
import type { ResourcePosition } from './resourcePosition';
import type { ResourceMetadata } from './resourceMetadata';
import type { ResourceProgress } from './resourceProgress';
import type { ResourceThumbnailUrls } from './resourceThumbnailUrls';

/**
 * Resource
 */
export interface Resource {
  id: string;
  title: string;
  description?: ResourceDescription;
  type: AppSchemasApiResourcesMediaType;
  filesize: number;
  citation: string;
  url?: ResourceUrl;
  /** Position in the resource list (0-based) */
  position?: ResourcePosition;
  metadata?: ResourceMetadata[];
  metadataHistory?: ResourceMetadata[];
  progress?: ResourceProgress;
  thumbnailUrls?: ResourceThumbnailUrls;
  oralExamRelevant?: boolean;
}
